<mat-form-field
  appearance="outline"
  class="{{ formFieldClass }}"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    label | translate
  }}</mat-label>
  <input matInput currencyMask [formControl]="control" [readonly]="readonly" />

  <mat-error *ngIf="control.invalid && control.touched && required">
    {{ requiredLabel | translate }}
  </mat-error>
</mat-form-field>
